import {trackPromise} from "react-promise-tracker";
import {HIDE_MSG, SHOW_MSG} from "../types";
import {clientID, URL} from '../url';
import language from "../languages/language";

function customFetch(serviceName,jsonValues,callback,dispatch,getState)
{
    return customFetchURL(URL,serviceName,jsonValues,callback,dispatch,getState);
}

function customFetchURL(url,serviceName,jsonValues,callback,dispatch,getState)
{
    return fetch(url +serviceName, {
        method: 'POST',
        headers: {Accept: 'application/json','Content-Type': 'application/json'},
        body: JSON.stringify(jsonValues),
        credentials: 'include'
    }).then(Response => {
        if(Response.status !== 200)
        {
            let message=Response.status;
            console.error("HTTP status error:",message);
            if(Response.status===404)
                message="Error, No se encontró el servidor";
            dispatch({type:SHOW_MSG,payload: {message:message,type:'error'}});
            if(callback)
                callback();
            return;
        }
        return Promise.all([Response, Response.json()]).catch(reason => {
            dispatch({type:SHOW_MSG,payload: {message:reason.message,type:'error'}});
            if(callback)
                callback();
        })
    }).catch(reason => {
        console.log(reason.message);
        dispatch({type:SHOW_MSG,payload: {message:language[getState().auth.language].serverError,type:'error'}});
        if(callback)
            callback();
    });
}

const call= (serviceName,jsonValues,callback,track=true) => async (dispatch, getState) =>
{
    if(jsonValues)
        jsonValues.clientID=clientID;
    let toTrack=customFetch(serviceName,jsonValues,callback,dispatch,getState);
    if(track)
        toTrack=trackPromise(toTrack);
    toTrack.then(result => {
            if(result) {
                if(result[1].success)
                    dispatch({type: HIDE_MSG});
                else
                {
                    let detail=result[1].detail;
                    dispatch({type: SHOW_MSG, payload: {message: detail,type:'error'}});
                }
            }
            if(callback)
                callback(result);
        }
    ).catch(reason => {
        dispatch({type:SHOW_MSG,payload: {message:reason.message,type:'error'}});
        if(callback)
            callback();
    });
};
export const callURL= (url,serviceName,jsonValues,callback,track=true) => async (dispatch, getState) =>
{
    let toTrack=customFetchURL(url,serviceName,jsonValues,callback,dispatch,getState);
    if(track)
        toTrack=trackPromise(toTrack);
    toTrack.then(result => {
            if(result) {
                if(result[1].success)
                    dispatch({type: HIDE_MSG});
                else
                {
                    let detail=result[1].detail;
                    dispatch({type: SHOW_MSG, payload: {message: detail,type:'error'}});
                }
            }
            if(callback)
                callback(result);
        }
    ).catch(reason => {
        dispatch({type:SHOW_MSG,payload: {message:reason.message,type:'error'}});
        if(callback)
            callback();
    });
    return toTrack;
};
export default call;
